import formatCurrency from "../../../../../../../../utils/helpers/formatCurrency";

export default function InvoiceDiscountsSection({ invoiceDetails }) {
  return (
    <table className="table !tw-text-black">
      <tr style={{ border: "0px solid #ecedee", backgroundColor: "#fff" }}>
        <th style={{ border: "0px solid #fff", width: "20px" }}>#</th>
        <th style={{ border: "0px solid #fff" }}>DISCOUNTS</th>
        <th style={{ border: "0px solid #fff", width: "200px" }}></th>
      </tr>

      {invoiceDetails.discounts?.map((item, index) => {
        return (
          <tr>
            <td>{index + 1}</td>
            <td style={{ textAlign: "left" }}>{item.title}</td>
            <td style={{ textAlign: "right", paddingRight: "20px" }}>
              {formatCurrency(item.amount)}
            </td>
          </tr>
        );
      })}
    </table>
  );
}
